import produce from "immer";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SILENT_LOGIN,
} from "../authService/accountActions";
import { OPEN_SIDEBAR, CLOSE_SIDEBAR } from "../authService/chatActions";
import { initialState } from "./initialState";

export const actions = {
  SET_ALERTRECEIPENTS: "SET_ALERTRECEIPENTS",
  SET_NOTIFICATION_LOGS: "SET_NOTIFICATION_LOGS",
  SET_PATIENTS: "SET_PATIENTS",
  SET_CLINICALREPORTDATA: "SET_CLINICALREPORTDATA",
  SET_BILLINGREPORTDATA: "SET_BILLINGREPORTDATA",
  SET_NOTESREPORTDATA: "SET_NOTESREPORTDATA",
  SET_MISSEDREPORTDATA: "SET_MISSEDREPORTDATA",
  SET_VITALREPORTDATA: "SET_VITALREPORTDATA",
  SET_CAREREPORTDATA: "SET_CAREREPORTDATA",
  SET_COMMUNICATIONREPORTDATA: "SET_COMMUNICATIONREPORTDATA",
  SET_INVENTORYREPORTDATA: "SET_INEVNTORYREPORTDATA",
  SET_PMDREPORTDATA: "SET_PMDREPORTDATA",
  SET_WRREPORTDATA: "SET_WRREPORTDATA",
  SET_ADVANCE_SEARCHED_PATIENTS: "SET_ADVANCE_SEARCHED_PATIENTS",
  SET_SMART_LIST_PATIENTS: "SET_SMART_LIST_PATIENTS",
  SET_VENDORS: "SET_VENDORS",
  SET_VENDOR_DEVICES: "SET_VENDOR_DEVICES",
  SET_VENDORS_NAMES: "SET_VENDORS_NAMES",
  SET_SHIPMENT_STATUS_NAMES: "SET_SHIPMENT_STATUS_NAMES",
  SET_VENDOR_DEVICE_NAMES: "SET_VENDOR_DEVICE_NAMES",
  SET_SAFE_RANGE_VALUES: "SET_SAFE_RANGE_VALUES",
  SET_SCHEDULE_VISITS: "SET_SCHEDULE_VISITS",
  SET_USERS: "SET_USERS",
  SET_ROLES: "SET_ROLES",
  SET_MEDICAL_ASSISTANTS: "SET_MEDICAL_ASSISTANTS",
  SET_CRONIC_CONDITIONS: "SET_CRONIC_CONDITIONS",
  SET_RACES_NAMES: "SET_RACES_NAMES",
  SET_PATIENT_NAMES: "SET_PATIENT_NAMES",
  SET_SERVICE_PROVIDER_NAMES: "SET_SERVICE_PROVIDER_NAMES",
  SET_MA_USER_NAMES: "SET_MA_USER_NAMES",
  SET_PRACTICE_TIMEZONE_NAMES: "SET_PRACTICE_TIMEZONE_NAMES",
  SET_PRACTICE_NAMES: "SET_PRACTICE_NAMES",
  SET_PRACTICES: "SET_PRACTICES",
  SET_SELECTED_PRACTICE: "SET_SELECTEDPRACTICE",
  SET_BATCHES: "SET_BATCHES",
  SET_VISITS: "SET_VISITS",
  SET_LOCATIONS: "SET_LOCATIONS",
  SET_PROVIDERS: "SET_PROVIDERS",
  SET_PRACTICE_STATS: "SET_PRACTICE_STATS",
  SET_HEALTH_INDICATOR_NAMES: "SET_HEALTH_INDICATOR_NAMES",
  SET_DEFAULT_PAGE_SIZE: "SET_DEFAULT_PAGE_SIZE",
  SET_DEFAULT_PAGE_SIZE_FOR_REPORTS: "SET_DEFAULT_PAGE_SIZE_FOR_REPORTS",
  SET_DEFAULT_PAGE_SIZE_FOR_PATIENTS: "SET_DEFAULT_PAGE_SIZE_FOR_PATIENTS",
  SET_SELECTED_RECORDS: "SET_SELECTED_RECORDS",
  SET_SERVICE_PROVIDERS: "SET_SERVICE_PROVIDERS",
  SET_PATIENT_READINGS: "SET_PATIENT_READINGS",
  SET_CLIENT: "SET_CLIENT",
  SET_CLIENTS: "SET_CLIENTS",
  SET_MODULES: "SET_MODULES",
  SET_SUB_MODULES: "SET_SUB_MODULES",
  SET_SELECTED_CLIENT: "SET_SELECTED_CLIENT",
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_SELECTED_FILTERED_PRODUCTS: "SET_SELECTED_FILTERED_PRODUCTS",
  SET_TOTAL_NUMBER_OF_PRODUCTS: "SET_TOTAL_NUMBER_OF_PRODUCTS",
  SET_TOTAL_NUMBER_OF_ARCHIEVED_PRODUCTS:
    "SET_TOTAL_NUMBER_OF_ARCHIEVED_PRODUCTS",
  SET_PRODUCTS_CSV_DATA: "SET_PRODUCTS_CSV_DATA",
  SET_ARCHIEVED_PRODUCTS: "SET_ARCHIEVED_PRODUCTS",
  SET_SHOW_ARCHIEVED_PRODUCTS: "SET_SHOW_ARCHIEVED_PRODUCTS",
  SET_SHOW_DRAFTED_PRODUCTS: "SET_SHOW_DRAFTED_PRODUCTS",
  SET_SHOW_PRODUCTS_TYPE: "SET_SHOW_PRODUCTS_TYPE",
  SET_SHOW_LIVE_PRODUCTS: "SET_SHOW_LIVE_PRODUCTS",
  SET_ORDERS: "SET_ORDERS",
  SET_TOTAL_NUMBER_OF_ORDERS: "SET_TOTAL_NUMBER_OF_ORDERS",
  LOADING_PRODUCTS: "LOADING_PRODUCTS",
  LOADING_ORDERS: "LOADING_ORDERS",
  SET_ALL_MARKETPLACES: "SET_ALL_MARKETPLACES",
  SET_ALL_ECOMMERCESYSTEMS: "SET_ALL_ECOMMERCESYSTEMS",
  SET_ALL_SHIPPINGTEMPLATES: "SET_ALL_SHIPPINGTEMPLATES",
  SET_ORIGIN_OF_COUNTRIES: "SET_ORIGIN_OF_COUNTRIES",
  SET_ACTIVE_NAVITEM: "SET_ACTIVE_NAVITEM",
  SET_SELECTED_NAVITEM: "SET_SELECTED_NAVITEM",
  SET_SHOW_NETWORK_ERROR_ALERT: "SET_SHOW_NETWORK_ERROR_ALERT",
  SET_INTERNET_CONNECTIVITY_ERROR: "SET_INTERNET_CONNECTIVITY_ERROR",
  SET_REPORT: "SET_REPORT",
  SET_PAGE: "SET_PAGE",
  SET_PAGE_SIZE: "SET_PAGE_SIZE",
  SET_QUERY: "SET_QUERY",
  SET_PRODUCTS_COUNTS: "SET_PRODUCTS_COUNTS",
  SET_PRODUCT_STATUSES: "SET_PRODUCT_STATUSES",
  SET_RESET_GLOBAL_STATE: "SET_RESET_GLOBAL_STATE",
  SET_TAGS: "SET_TAGS",
  SET_TAG_TYPES: "SET_TAG_TYPES",
  SET_TRAININGS: "SET_TRAININGS",
  SET_ALL_ACTIVITIES: "SET_ALL_ACTIVITIES",
  SET_TRAINING_MODULES: "SET_TRAINING_MODULES",
  SET_TRAINING_SESSIONS: "SET_TRAINING_SESSIONS",
  SET_TRAINING_COSTS: "SET_TRAINING_COSTS",
  SET_TRAINING_NAMES: "SET_TRAINING_NAMES",
  SET_TRAINING_MODULE_NAMES: "SET_TRAINING_MODULE_NAMES",
  SET_PARITICIPANTS: "SET_PARITICIPANTS",
  SET_ORGANIZATION_TYPE_NAMES: "SET_ORGANIZATION_TYPE_NAMES",
  SET_ORGANIZATION_NAMES: "SET_ORGANIZATION_NAMES",
  SET_ACADEMIC_QUALIFICATION_NAMES: "SET_ACADEMIC_QUALIFICATION_NAMES",
  SET_PROVINCE_NAMES: "SET_PROVINCE_NAMES",
  SET_DISTRICT_NAMES: "SET_DISTRICT_NAMES",
  SET_PROJECT_NAMES: "SET_PROJECT_NAMES",
  SET_SURVEY_NAMES: "SET_SURVEY_NAMES",
  SET_BROADER_TRAINING_AREAS: "SET_BROADER_TRAINING_AREAS",
  SET_CITY_NAMES: "SET_CITY_NAMES",
  SET_TRAINING_MAPS_DATA: "SET_TRAINING_MAPS_DATA",
  SET_TRAINING_EVALUATION: "SET_TRAINING_EVALUATION",
  SET_EMAIL_SMS_LOGS: "SET_EMAIL_SMS_LOGS",
  SET_SMS_GROUPS: "SET_SMS_GROUPS",
  SET_EMAIL_GROUPS: "SET_EMAIL_GROUPS",
  SET_DONORS_COLLABORATINGAGENCIES: "SET_DONORS_COLLABORATINGAGENCIES",
  SET_ORGANIZATION_TYPES: "SET_ORGANIZATION_TYPES",
  SET_RELATIONSHIP_TYPES: "SET_RELATIONSHIP_TYPES",
  SET_GEOGRAPHICAL_AREA: "SET_GEOGRAPHICAL_AREA",
  SET_DISTRICT: "SET_DISTRICT",
  SET_PROJECTS: "SET_PROJECTS",
  SET_GROUPS: "SET_GROUPS",
  SET_COURSES: "SET_COURSES",
  SET_TRAINING_CALENDAR: "SET_TRAINING_CALENDAR",
  SET_RESOURCE_PERSON: "SET_RESOURCE_PERSON",
  SET_PROJECT_FUNDINGS: "SET_PROJECT_FUNDINGS",
  SET_APPROVED_HEAD_NAMES: "SET_APPROVED_HEAD_NAMES",
  SET_RESOURCE_PERSONS_TRAININGS: "SET_RESOURCE_PERSONS_TRAININGS",
  SET_RESOURCE_PERSONS_NAMES: "SET_RESOURCE_PERSONS_NAMES",
  SET_TRAINING_SESSION_NAMES: "SET_TRAINING_SESSION_NAMES",
  SET_ATTACHMENTS: "SET_ATTACHMENTS",
  SET_TOPIC_NAMES: "SET_TOPIC_NAMES",
  SET_QUIZZES: "SET_QUIZZES",

  SET_4W_ORGANIZATIONS: "SET_4W_ORGANIZATIONS",
  SET_ACTIVITIES: "SET_ACTIVITIES",
  SET_ACTIVITY_TYPE_NAMES: "SET_ACTIVITY_TYPE_NAMES",
  SET_REGISTRATIONS: "SET_REGISTRATIONS",
  SET_TRAINING_REGISTRATIONS: "SET_TRAINING_REGISTRATIONS",
  SET_COURSE_NAMES: "SET_COURSE_NAMES",
  SET_PARTICIPANT_NAMES: "SET_PARTICIPANT_NAMES",
  SET_SECTIONS: "SET_SECTIONS",
  SET_TOPICS: "SET_TOPICS",
  SET_SECTIONS_NAMES: "SET_SECTIONS_NAMES",
  SET_ACTIVITIES_COSTS: "SET_ACTIVITIES_COSTS",
  SET_ACTIVITIES_NAMES: "SET_ACTIVITIES_NAMES",
  SET_FUNDINGS_NAME: "SET_FUNDINGS_NAME",
  SET_APPROVED_HEADS: "SET_APPROVED_HEADS",
  SET_ACTIVITY_TYPES: "SET_ACTIVITY_TYPES",
  SET_QUIZ_ATTEMPTS: "SET_QUIZ_ATTEMPTS",
  SET_QUIZ_NAMES: "SET_QUIZ_NAMES",
  SET_QUIZ_QUESTION_TEXTS: "SET_QUIZ_QUESTION_TEXTS",
  SET_THEMATIC_AREAS: "SET_THEMATIC_AREAS",
  SET_PROVINCES: "SET_PROVINCES",
  SET_DISTRICTS: "SET_DISTRICTS",
  SET_CITIES: "SET_CITIES",
  SET_ALL_DISTRICTS: "SET_ALL_DISTRICTS",
  SET_DOCUMENT_CATEGORIES: "SET_DOCUMENT_CATEGORIES",
  SET_DOCUMENT_CATEGORY_NAMES: "SET_DOCUMENT_CATEGORY_NAMES",
  SET_WEBSITE_CONTENTS: "SET_WEBSITE_CONTENTS",
  SET_DISABILITY_TYPES: "SET_DISABILITY_TYPES",
  SET_ACADEMIC_QUALIFICATIONS: "SET_ACADEMIC_QUALIFICATIONS",
  SET_AREAS_OF_SPECIALITIES: "SET_AREAS_OF_SPECIALITIES",
  SET_AREAS_OF_SPECIALITY_NAMES: "SET_AREAS_OF_SPECIALITY_NAMES",
  SET_DISABILITY_TYPE_NAMES: "SET_DISABILITY_TYPE_NAMES",
  SET_MY_COURSES: "SET_MY_COURSES",
  SET_QUIZ_QUESTIONS: "SET_QUIZ_QUESTIONS",
  SET_LIVE_TRAININGS: "SET_LIVE_TRAININGS",
  SET_PARTICIPANT_TRAININGS: "SET_PARTICIPANT_TRAININGS",
  SET_DONORS_COLLABORATINGAGENCY_ORGANIZATIONS:
    "SET_DONORS_COLLABORATINGAGENCY_ORGANIZATIONS",
  SET_SECTION_FILTERS: "SET_SECTION_FILTERS",
  SET_TOPIC_FILTERS: "SET_TOPIC_FILTERS",
  SET_ATTACHMENT_FILTERS: "SET_ATTACHMENT_FILTERS",
  SET_QUIZ_FILTERS: "SET_QUIZ_FILTERS",
  SET_REGISTRATION_FILTERS: "SET_REGISTRATION_FILTERS",
  SET_QUIZQUESTION_FILTERS: "SET_QUIZQUESTION_FILTERS",
  SET_REDIRECT_PATH: "SET_REDIRECT_PATH",
  SET_SURVEYS: "SET_SURVEYS",
  SET_RESPONDENTS: "SET_RESPONDENTS",
  SET_QUESTIONS: "SET_QUESTIONS",
  SET_LIBRARY_DOCUMENTS: "set_library_documents",
  SET_DOC_CATEGORIES_NAMES: "set_doc_categories_names",
  SET_DOC_SUB_CATEGORIES1_NAMES: "set_doc_sub_categories1_names",
  SET_DOC_SUB_CATEGORIES2_NAMES: "set_doc_sub_categories2_names",
  SET_THEMATIC_AREA_NAMES: "set_thematic_area_names",
  SET_ALBUMS: "set_albums",
  SET_GALLERIES_NAMES: "set_galleries_names",
  SET_GALLERY_ALBUMS: "set_gallery_albums",
  SET_ALBUM_DOCUMENTS: "set_album_documents",
  SET_DONORS_COLLABORATINGAGENCIES_PROJECTBRIEF_REPORT:
    "set_donors_collaboratingagencies_projectbrief_report",
  SET_RECONCILIATION_FUNDING_COST_REPORT:
    "set_reconciliation_funding_cost_report",

  SET_4W_ORGANIZATION_NAMES: "SET_4W_ORGANIZATION_NAMES",
  SET_TRAINING_MODE_NAMES: "SET_TRAINING_MODE_NAMES",
  SET_CONSULTANT_NAMES: "SET_CONSULTANT_NAMES",
  SET_ADMIN_USERS_NAMES: "SET_ADMIN_USERS_NAMES",
  SET_BROADER_TRAINING_AREAS_LIST: "SET_BROADER_TRAINING_AREAS_LIST",
  SET_SURVEY_SECTIONS: "SET_SURVEY_SECTIONS",
  SET_SURVEY_SECTION_NAMES: "SET_SURVEY_SECTION_NAMES",
  SET_DOCUMENT_AUTHORS: "SET_DOCUMENT_AUTHORS",
  SET_DOCUMENT_PUBLISHERS: "SET_DOCUMENT_PUBLISHERS",
  SET_COMPILING_AGENCIES: "SET_COMPILING_AGENCIES",
  SET_DOCUMENT_PUBLISHER_NAMES: "SET_DOCUMENT_PUBLISHER_NAMES",
  SET_DOCUMENT_AUTHOR_NAMES: "SET_DOCUMENT_AUTHOR_NAMES",
  SET_COMPILING_AGENCIES_NAMES: "SET_COMPILING_AGENCIES_NAMES",
  SET_SELECTED_COURSE_TAB: "SET_SELECTED_COURSE_TAB",
  SET_TRAINING_EVALUATIONS: "SET_TRAINING_EVALUATIONS",
  SET_ROLE_PEMISSIONS: "SET_ROLE_PEMISSIONS",
  SET_EMPLOYEES: "SET_EMPLOYEES",
  SET_EMPLOYEES_EVENTS: "SET_EMPLOYEES_EVENTS",
  SET_DIRECTORATE_TYPE_NAMES: "SET_DIRECTORATE_TYPE_NAMES",
  SET_FEDERAL_DEPARTMENTS_NAMES: "SET_FEDERAL_DEPARTMENTS_NAMES",
  SET_PROVINCIAL_DEPARTMENTS_NAMES: "SET_PROVINCIAL_DEPARTMENTS_NAMES",
  SET_NDMA_APPOINTMENTS_NAMES: "SET_NDMA_APPOINTMENTS_NAMES",
  SET_NDMA_SECTIONS_NAMES: "SET_NDMA_SECTIONS_NAMES",
  SET_EMPLOYEE_EVENT_TYPE_NAMES: "SET_EMPLOYEE_EVENT_TYPE_NAMES",
  SET_EMPLOYEE_EVENT_CONDUCT_MODE_NAMES:
    "SET_EMPLOYEE_EVENT_CONDUCT_MODE_NAMES",
  SET_EMPLOYEE_EVENT_FUNDING_STATUS_NAMES:
    "SET_EMPLOYEE_EVENT_FUNDING_STATUS_NAMES",
  SET_EMPLOYEE_EVENT_ORGANIZER_NAMES: "SET_EMPLOYEE_EVENT_ORGANIZER_NAMES",
  SET_NDMA_WING_NAMES: "SET_NDMA_WING_NAMES",
  SET_ARMED_FORCE_TYPE_NAMES: "SET_ARMED_FORCE_TYPE_NAMES",
  SET_DASHBOARD_CONTENT: "SET_DASHBOARD_CONTENT",
  SET_USER: "SET_USER",
  OPEN_PATIENT_MAIN_DIALOG: "OPEN_PATIENT_MAIN_DIALOG",
  OPEN_PATIENT_READINGS_DIALOG: "OPEN_PATIENT_READINGS_DIALOG",
  // SET_PATIENT_NEW_DASHBOARD: "SET_PATIENT_NEW_DASHBOARD"
  SET_TEMPLATE: "SET_TEMPLATE",
};
export const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_ALERTRECEIPENTS:
      return {
        ...state,
        alertReceipents: action.payload,
      };
    case actions.SET_RESET_GLOBAL_STATE:
      return initialState;
    case actions.SET_REDIRECT_PATH:
      return {
        ...state,
        redirectPath: action.payload,
      };
    case actions.SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case actions.SET_DASHBOARD_CONTENT:
      return {
        ...state,
        dashboardContent: action.payload,
      };
    case actions.SET_NOTIFICATION_LOGS:
      return {
        ...state,
        notificationLogs: action.payload,
      };
    case actions.SET_PATIENTS:
      return {
        ...state,
        patients: action.payload,
      };
    case actions.SET_CLINICALREPORTDATA:
      return {
        ...state,
        clinicalreport: action.payload,
      };
    case actions.SET_BILLINGREPORTDATA:
      return {
        ...state,
        billingreport: action.payload,
      };
    case actions.SET_NOTESREPORTDATA:
      return {
        ...state,
        notesreport: action.payload,
      };
    case actions.SET_MISSEDREPORTDATA:
      return {
        ...state,
        missedreport: action.payload,
      };
    case actions.SET_VITALREPORTDATA:
      return {
        ...state,
        vitalreport: action.payload,
      };
    case actions.SET_CAREREPORTDATA:
      return {
        ...state,
        carereport: action.payload,
      };
    case actions.SET_COMMUNICATIONREPORTDATA:
      return {
        ...state,
        communicationreport: action.payload,
      };
    case actions.SET_INVENTORYREPORTDATA:
      return {
        ...state,
        inventoryreport: action.payload,
      };
    case actions.SET_PMDREPORTDATA:
      return {
        ...state,
        pmdreport: action.payload,
      };
    case actions.SET_WRREPORTDATA:
      return {
        ...state,
        wrreport: action.payload,
      };
    case actions.SET_ADVANCE_SEARCHED_PATIENTS:
      return {
        ...state,
        advanceSearchedPatients: action.payload,
      };
    case actions.SET_SMART_LIST_PATIENTS:
      return {
        ...state,
        smartListPatients: action.payload,
      };
    case actions.SET_VENDORS:
      return {
        ...state,
        vendors: action.payload,
      };
    case actions.SET_VENDOR_DEVICES:
      return {
        ...state,
        vendorDevices: action.payload,
      };
    case actions.SET_SAFE_RANGE_VALUES:
      return {
        ...state,
        safeRangeValues: action.payload,
      };
    case actions.SET_SCHEDULE_VISITS:
      return {
        ...state,
        scheduleVisits: action.payload,
      };

    case actions.SET_USERS:
      return {
        ...state,
        usersList: action.payload,
      };
    case actions.SET_ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case actions.SET_MEDICAL_ASSISTANTS:
      return {
        ...state,
        medicalAssistants: action.payload,
      };

    case actions.SET_CRONIC_CONDITIONS:
      return {
        ...state,
        cronicConditions: action.payload,
      };

    case actions.SET_RACES_NAMES:
      return {
        ...state,
        racesNames: action.payload,
      };
    case actions.SET_PATIENT_NAMES:
      return {
        ...state,
        patientNames: action.payload,
      };
    case actions.SET_SERVICE_PROVIDER_NAMES:
      return {
        ...state,
        serviceProviderNames: action.payload,
      };
    case actions.SET_MA_USER_NAMES:
      return {
        ...state,
        setMaUserNames: action.payload,
      };
    case actions.SET_VENDORS_NAMES:
      return {
        ...state,
        vendorNames: action.payload,
      };
    case actions.SET_SHIPMENT_STATUS_NAMES:
      return {
        ...state,
        shipmentStatusNames: action.payload,
      };
    case actions.SET_VENDOR_DEVICE_NAMES:
      return {
        ...state,
        vendorDeviceNames: action.payload,
      };
    case actions.SET_PRACTICE_TIMEZONE_NAMES:
      return {
        ...state,
        practiceTimeZoneNames: action.payload,
      };
    case actions.SET_PRACTICE_NAMES:
      return {
        ...state,
        practiceNames: action.payload,
      };
    case actions.SET_PRACTICES:
      return {
        ...state,
        practices: action.payload,
      };
      case actions.SET_SELECTED_PRACTICE:
        return {
          ...state,
          practice: action.payload,
        };
        case actions.SET_PRACTICE_STATS:
          return {
            ...state,
            practicestats: action.payload,
          };
          case actions.SET_BATCHES:
            return {
              ...state,
              batches: action.payload,
            };
            case actions.SET_VISITS:
              return {
                ...state,
                visits: action.payload,
              };
              case actions.SET_LOCATIONS:
                return {
                  ...state,
                  locations: action.payload,
                };
              case actions.SET_PROVIDERS:
                return {
                  ...state,
                  providers: action.payload,
                };
    case actions.SET_HEALTH_INDICATOR_NAMES:
      return {
        ...state,
        healthIndicatorNames: action.payload,
      };
    case actions.SET_DEFAULT_PAGE_SIZE:
      return {
        ...state,
        defaultPageSize: action.payload,
      };
    case actions.SET_DEFAULT_PAGE_SIZE_FOR_REPORTS:
      return {
        ...state,
        defaultPageSizeforReports: action.payload,
      };
    case actions.SET_DEFAULT_PAGE_SIZE_FOR_PATIENTS:
      return {
        ...state,
        defaultPageSizeforPatients: action.payload,
      };
    case actions.SET_SELECTED_RECORDS:
      return {
        ...state,
        Records: action.payload,
      };

    case actions.SET_ROLE_PEMISSIONS:
      return {
        ...state,
        rolePermissions: action.payload,
      };
    case actions.SET_DONORS_COLLABORATINGAGENCY_ORGANIZATIONS:
      return {
        ...state,
        donorsCollaboratingagencyOrganizations: action.payload,
      };
    case actions.SET_DOCUMENT_PUBLISHER_NAMES:
      return {
        ...state,
        documentPublisherNames: action.payload,
      };
    case actions.SET_DOCUMENT_AUTHOR_NAMES:
      return {
        ...state,
        documentAuthorNames: action.payload,
      };
    case actions.SET_COMPILING_AGENCIES_NAMES:
      return {
        ...state,
        compilingAgencyNames: action.payload,
      };
    case actions.SET_DOCUMENT_AUTHORS:
      return {
        ...state,
        documentAuthors: action.payload,
      };
    case actions.SET_DOCUMENT_PUBLISHERS:
      return {
        ...state,
        documentPublishers: action.payload,
      };
    case actions.SET_COMPILING_AGENCIES:
      return {
        ...state,
        compilingAgencies: action.payload,
      };
    case actions.SET_CONSULTANT_NAMES:
      return {
        ...state,
        consultantNames: action.payload,
      };
    case actions.SET_ADMIN_USERS_NAMES:
      return {
        ...state,
        adminUsersNames: action.payload,
      };
    case actions.SET_BROADER_TRAINING_AREAS_LIST:
      return {
        ...state,
        broaderTrainingAreasList: action.payload,
      };
    case actions.SET_SURVEY_SECTIONS:
      return {
        ...state,
        surveySections: action.payload,
      };
    case actions.SET_SURVEY_SECTION_NAMES:
      return {
        ...state,
        surveySectionNames: action.payload,
      };

    case actions.SET_4W_ORGANIZATION_NAMES:
      return {
        ...state,
        fourWOrganizationNames: action.payload,
      };
    case actions.SET_SECTION_FILTERS:
      return {
        ...state,
        sectionFilters: action.payload,
      };
    case actions.SET_TOPIC_FILTERS:
      return {
        ...state,
        topicFilters: action.payload,
      };
    case actions.SET_ATTACHMENT_FILTERS:
      return {
        ...state,
        attachmentFilters: action.payload,
      };
    case actions.SET_QUIZ_FILTERS:
      return {
        ...state,
        quizFilters: action.payload,
      };
    case actions.SET_REGISTRATION_FILTERS:
      return {
        ...state,
        registrationFilters: action.payload,
      };
    case actions.SET_QUIZQUESTION_FILTERS:
      return {
        ...state,
        quizQuestionFilters: action.payload,
      };
    case actions.SET_4W_ORGANIZATIONS:
      return {
        ...state,
        fourWOrganizations: action.payload,
      };
    case actions.SET_TRAINING_CALENDAR:
      return {
        ...state,
        trainingCalendar: action.payload,
      };
    case actions.SET_TRAINING_EVALUATION:
      return {
        ...state,
        trainingEvaluation: action.payload,
      };
    case actions.SET_TRAINING_MAPS_DATA:
      return {
        ...state,
        trainingMapsData: action.payload,
      };
    case actions.SET_TRAININGS:
      return {
        ...state,
        trainings: action.payload,
      };
    case actions.SET_ALL_ACTIVITIES:
      return {
        ...state,
        allActivities: action.payload,
      };
    case actions.SET_TRAINING_MODULES:
      return {
        ...state,
        trainingModules: action.payload,
      };
    case actions.SET_BROADER_TRAINING_AREAS:
      return {
        ...state,
        broaderTrainingAreas: action.payload,
      };
    case actions.SET_PROVINCE_NAMES:
      return {
        ...state,
        provinceNames: action.payload,
      };
    case actions.SET_DISTRICT_NAMES:
      return {
        ...state,
        districtNames: action.payload,
      };
    case actions.SET_CITY_NAMES:
      return {
        ...state,
        cityNames: action.payload,
      };
    case actions.SET_TRAINING_NAMES:
      return {
        ...state,
        trainingNames: action.payload,
      };
    case actions.SET_TRAINING_MODULE_NAMES:
      return {
        ...state,
        trainingModuleNames: action.payload,
      };
    case actions.SET_PROJECT_NAMES:
      return {
        ...state,
        projectNames: action.payload,
      };
    case actions.SET_ALBUMS:
      return {
        ...state,
        albums: action.payload,
      };
    case actions.SET_GALLERIES_NAMES:
      return {
        ...state,
        galleriesNames: action.payload,
      };
    case actions.SET_GALLERY_ALBUMS:
      return {
        ...state,
        galleryAbums: action.payload,
      };
    case actions.SET_ALBUM_DOCUMENTS:
      return {
        ...state,
        albumDocuments: action.payload,
      };

    case actions.SET_SURVEY_NAMES:
      return {
        ...state,
        surveyNames: action.payload,
      };
    case actions.SET_TRAINING_SESSIONS:
      return {
        ...state,
        trainingSessions: action.payload,
      };
    case actions.SET_TRAINING_COSTS:
      return {
        ...state,
        trainingCosts: action.payload,
      };
    case actions.SET_PARITICIPANTS:
      return {
        ...state,
        participants: action.payload,
      };
    case actions.SET_ORGANIZATION_TYPE_NAMES:
      return {
        ...state,
        organizationTypeNames: action.payload,
      };
    case actions.SET_ORGANIZATION_NAMES:
      return {
        ...state,
        organizationNames: action.payload,
      };
    case actions.SET_ACADEMIC_QUALIFICATION_NAMES:
      return {
        ...state,
        academicQualificationNames: action.payload,
      };
    case actions.SET_EMAIL_SMS_LOGS:
      return {
        ...state,
        emailSmsLogs: action.payload,
      };
    case actions.SET_SMS_GROUPS:
      return {
        ...state,
        smsGroups: action.payload,
      };
    case actions.SET_EMAIL_GROUPS:
      return {
        ...state,
        emailGroups: action.payload,
      };
    case actions.SET_DONORS_COLLABORATINGAGENCIES:
      return {
        ...state,
        donors_collaboratingagencies: action.payload,
      };

    case actions.SET_DOC_CATEGORIES_NAMES:
      return {
        ...state,
        documentCategoriesNames: action.payload,
      };
    case actions.SET_DOC_SUB_CATEGORIES1_NAMES:
      return {
        ...state,
        documentSubCategories1Names: action.payload,
      };
    case actions.SET_DOC_SUB_CATEGORIES2_NAMES:
      return {
        ...state,
        documentSubCategories2Names: action.payload,
      };
    case actions.SET_THEMATIC_AREA_NAMES:
      return {
        ...state,
        thematicAreaNames: action.payload,
      };

    case actions.SET_LIBRARY_DOCUMENTS:
      return {
        ...state,
        libraryDocuments: action.payload,
      };
    case actions.SET_DONORS_COLLABORATINGAGENCIES_PROJECTBRIEF_REPORT:
      return {
        ...state,
        donors_collaboratingagenciesprojectbriefReport: action.payload,
      };
    case actions.SET_RECONCILIATION_FUNDING_COST_REPORT:
      return {
        ...state,
        reconciliationfundingcostReport: action.payload,
      };

    case actions.SET_ORGANIZATION_TYPES:
      return {
        ...state,
        organizationTypes: action.payload,
      };
    case actions.SET_RELATIONSHIP_TYPES:
      return {
        ...state,
        relationshipTypes: action.payload,
      };
    case actions.SET_GEOGRAPHICAL_AREA:
      return {
        ...state,
        geographicalAreas: action.payload,
      };
    case actions.SET_DISTRICT:
      return {
        ...state,
        distrcitsNames: action.payload,
      };
    case actions.SET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
      };
    case actions.SET_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case actions.SET_COURSES:
      return {
        ...state,
        courses: action.payload,
      };
    case actions.SET_REGISTRATIONS:
      return {
        ...state,
        registrations: action.payload,
      };
    case actions.SET_TRAINING_REGISTRATIONS:
      return {
        ...state,
        trainingRegistrations: action.payload,
      };
    case actions.SET_COURSE_NAMES:
      return {
        ...state,
        courseNames: action.payload,
      };
    case actions.SET_PARTICIPANT_NAMES:
      return {
        ...state,
        participantNames: action.payload,
      };
    case actions.SET_SECTIONS:
      return {
        ...state,
        sections: action.payload,
      };
    case actions.SET_TOPICS:
      return {
        ...state,
        topics: action.payload,
      };
    case actions.SET_SECTIONS_NAMES:
      return {
        ...state,
        sectionNames: action.payload,
      };
    case actions.SET_QUIZ_ATTEMPTS:
      return {
        ...state,
        quizAttempts: action.payload,
      };
    case actions.SET_QUIZ_NAMES:
      return {
        ...state,
        quizNames: action.payload,
      };
    case actions.SET_QUIZ_QUESTION_TEXTS:
      return {
        ...state,
        quizQuestionTexts: action.payload,
      };
    case actions.SET_RESOURCE_PERSON:
      return {
        ...state,
        resourcePersons: action.payload,
      };
    case actions.SET_RESOURCE_PERSONS_TRAININGS:
      return {
        ...state,
        resourcePersonsTrainings: action.payload,
      };
    case actions.SET_RESOURCE_PERSONS_NAMES:
      return {
        ...state,
        resourcePersonNames: action.payload,
      };
    case actions.SET_TRAINING_SESSION_NAMES:
      return {
        ...state,
        trainingSessionNames: action.payload,
      };
    case actions.SET_ATTACHMENTS:
      return {
        ...state,
        attachments: action.payload,
      };
    case actions.SET_TOPIC_NAMES:
      return {
        ...state,
        topicNames: action.payload,
      };
    case actions.SET_QUIZZES:
      return {
        ...state,
        quizzes: action.payload,
      };
    case actions.SET_PROJECT_FUNDINGS:
      return {
        ...state,
        projectFundings: action.payload,
      };
    case actions.SET_APPROVED_HEAD_NAMES:
      return {
        ...state,
        approvedHeadNames: action.payload,
      };
    case actions.SET_ACTIVITIES:
      return {
        ...state,
        activities: action.payload,
      };
    case actions.SET_ACTIVITY_TYPE_NAMES:
      return {
        ...state,
        activityTypeNames: action.payload,
      };
    case actions.SET_ACTIVITIES_COSTS:
      return {
        ...state,
        activitiesCosts: action.payload,
      };
    case actions.SET_ACTIVITIES_NAMES:
      return {
        ...state,
        activitiesNames: action.payload,
      };
    case actions.SET_FUNDINGS_NAME:
      return {
        ...state,
        fundingsNames: action.payload,
      };
    case actions.SET_APPROVED_HEADS:
      return {
        ...state,
        approvedHeads: action.payload,
      };
    case actions.SET_ACTIVITY_TYPES:
      return {
        ...state,
        activityTypes: action.payload,
      };
    case actions.SET_THEMATIC_AREAS:
      return {
        ...state,
        thematicAreas: action.payload,
      };
    case actions.SET_PROVINCES:
      return {
        ...state,
        provinces: action.payload,
      };
    case actions.SET_DISTRICTS:
      return {
        ...state,
        districts: action.payload,
      };
    case actions.SET_CITIES:
      return {
        ...state,
        cities: action.payload,
      };
    case actions.SET_ALL_DISTRICTS:
      return {
        ...state,
        allDistrictNames: action.payload,
      };
    case actions.SET_DOCUMENT_CATEGORIES:
      return {
        ...state,
        documentCategories: action.payload,
      };
    case actions.SET_DOCUMENT_CATEGORY_NAMES:
      return {
        ...state,
        documentCategoryNames: action.payload,
      };
    case actions.SET_WEBSITE_CONTENTS:
      return {
        ...state,
        websiteContents: action.payload,
      };
    case actions.SET_DISABILITY_TYPES:
      return {
        ...state,
        disabilityTypes: action.payload,
      };
    case actions.SET_DISABILITY_TYPE_NAMES:
      return {
        ...state,
        disabilityTypeNames: action.payload,
      };
    case actions.SET_ACADEMIC_QUALIFICATIONS:
      return {
        ...state,
        academicQualifications: action.payload,
      };
    case actions.SET_AREAS_OF_SPECIALITIES:
      return {
        ...state,
        areasOfSpecialities: action.payload,
      };
    case actions.SET_AREAS_OF_SPECIALITY_NAMES:
      return {
        ...state,
        areasOfSpecialityNames: action.payload,
      };
    case actions.SET_MY_COURSES:
      return {
        ...state,
        myCourses: action.payload,
      };
    case actions.SET_SELECTED_COURSE_TAB:
      return {
        ...state,
        selectedCourseTab: action.payload,
      };
    case actions.SET_TRAINING_EVALUATIONS:
      return {
        ...state,
        trainingEvaluations: action.payload,
      };
    case actions.SET_QUIZ_QUESTIONS:
      return {
        ...state,
        quizQuestions: action.payload,
      };
    case actions.SET_LIVE_TRAININGS:
      return {
        ...state,
        liveTrainings: action.payload,
      };
    case actions.SET_PARTICIPANT_TRAININGS:
      return {
        ...state,
        participantTrainings: action.payload,
      };
    case actions.SET_SURVEYS:
      return {
        ...state,
        surveys: action.payload,
      };
    case actions.SET_RESPONDENTS:
      return {
        ...state,
        respondents: action.payload,
      };
    case actions.SET_QUESTIONS:
      return {
        ...state,
        questions: action.payload,
      };

    case actions.SET_TRAINING_MODE_NAMES:
      return {
        ...state,
        trainingModeNames: action.payload,
      };
    case actions.SET_MODULES:
      return {
        ...state,
        modules: action.payload,
      };
    case actions.SET_SUB_MODULES:
      return {
        ...state,
        subModules: action.payload,
      };
    case actions.SET_CLIENT:
      return {
        ...state,
        client: action.payload,
      };
    case actions.SET_CLIENTS:
      return {
        ...state,
        clients: action.payload,
      };
    case actions.SET_REPORT:
      return {
        ...state,
        report: action.payload,
      };

    case actions.SET_SELECTED_CLIENT:
      return {
        ...state,
        selectedClient: action.payload,
      };
    case actions.SET_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      };
    case actions.SET_PRODUCTS_COUNTS:
      return {
        ...state,
        productsCounts: action.payload,
      };
    case actions.SET_SELECTED_FILTERED_PRODUCTS:
      return {
        ...state,
        selectedFilteredProducts: action.payload,
      };
    case actions.SET_TOTAL_NUMBER_OF_PRODUCTS:
      return {
        ...state,
        totalProducts: action.payload,
      };
    case actions.SET_TOTAL_NUMBER_OF_ARCHIEVED_PRODUCTS:
      return {
        ...state,
        totalArchievedProducts: action.payload,
      };
    case actions.SET_PRODUCTS_CSV_DATA:
      return {
        ...state,
        productsCSVData: action.payload,
      };
    case actions.SET_ARCHIEVED_PRODUCTS:
      return {
        ...state,
        archievedProducts: action.payload,
      };
    case actions.SET_SHOW_ARCHIEVED_PRODUCTS:
      return {
        ...state,
        showArchievedProducts: action.payload,
      };
    case actions.SET_SHOW_PRODUCTS_TYPE:
      return {
        ...state,
        showProductsType: action.payload,
      };
    case actions.SET_SHOW_DRAFTED_PRODUCTS:
      return {
        ...state,
        showDraftedProducts: action.payload,
      };
    case actions.SET_SHOW_LIVE_PRODUCTS:
      return {
        ...state,
        showLiveProducts: action.payload,
      };
    case actions.LOADING_PRODUCTS:
      return {
        ...state,
        loadingProducts: action.payload,
      };
    case actions.SET_ORDERS:
      return {
        ...state,
        orders: action.payload,
      };
    case actions.SET_TOTAL_NUMBER_OF_ORDERS:
      return {
        ...state,
        totalOrders: action.payload,
      };
    case actions.LOADING_ORDERS:
      return {
        ...state,
        loadingOrders: action.payload,
      };
    case actions.SET_ALL_MARKETPLACES:
      return {
        ...state,
        marketplaces: action.payload,
      };
    case actions.SET_ALL_ECOMMERCESYSTEMS:
      return {
        ...state,
        ecommerceSystems: action.payload,
      };
    case actions.SET_ALL_SHIPPINGTEMPLATES:
      return {
        ...state,
        shippingTemplates: action.payload,
      };
    case actions.SET_ORIGIN_OF_COUNTRIES:
      return {
        ...state,
        originOfCountries: action.payload,
      };
    case actions.SET_ACTIVE_NAVITEM:
      return {
        ...state,
        collapseOpen: action.payload,
      };
    case actions.SET_SELECTED_NAVITEM:
      return {
        ...state,
        selectedCollapse: action.payload,
      };
    case actions.SET_SHOW_NETWORK_ERROR_ALERT:
      return {
        ...state,
        showNetworkErrorAlert: action.payload,
      };
    case actions.SET_INTERNET_CONNECTIVITY_ERROR:
      return {
        ...state,
        internetConnectivityErrorAlert: action.payload,
        showNetworkErrorAlert: action.payload,
      };
    case actions.SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case actions.SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actions.SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case actions.SET_PRODUCT_STATUSES:
      return {
        ...state,
        productStatuses: action.payload,
      };
    case actions.SET_TAGS:
      return {
        ...state,
        tags: action.payload,
      };
    case actions.SET_TAG_TYPES:
      return {
        ...state,
        tagTypes: action.payload,
      };
    case actions.SET_EMPLOYEES:
      return {
        ...state,
        employees: action.payload,
      };
    case actions.SET_EMPLOYEES_EVENTS:
      return {
        ...state,
        employeeEvents: action.payload,
      };
    case actions.SET_DIRECTORATE_TYPE_NAMES:
      return {
        ...state,
        directorateTypeNames: action.payload,
      };
    case actions.SET_FEDERAL_DEPARTMENTS_NAMES:
      return {
        ...state,
        federalDepartmentNames: action.payload,
      };
    case actions.SET_PROVINCIAL_DEPARTMENTS_NAMES:
      return {
        ...state,
        provincialDepartmentNames: action.payload,
      };
    case actions.SET_NDMA_APPOINTMENTS_NAMES:
      return {
        ...state,
        ndmaAppointmentsNames: action.payload,
      };
    case actions.SET_NDMA_SECTIONS_NAMES:
      return {
        ...state,
        ndmaSectionsNames: action.payload,
      };

    case actions.SET_EMPLOYEE_EVENT_TYPE_NAMES:
      return {
        ...state,
        employeeEventTypeNames: action.payload,
      };
    case actions.SET_EMPLOYEE_EVENT_CONDUCT_MODE_NAMES:
      return {
        ...state,
        employeeEventConductModeNames: action.payload,
      };
    case actions.SET_EMPLOYEE_EVENT_FUNDING_STATUS_NAMES:
      return {
        ...state,
        employeeEventFundingStatusNames: action.payload,
      };
    case actions.SET_EMPLOYEE_EVENT_ORGANIZER_NAMES:
      return {
        ...state,
        employeeEventOrganizerNames: action.payload,
      };
    case actions.SET_NDMA_WING_NAMES:
      return {
        ...state,
        ndmaWingNames: action.payload,
      };
    case actions.SET_ARMED_FORCE_TYPE_NAMES:
      return {
        ...state,
        armedForceTypeNames: action.payload,
      };
    // case actions.SET_PATIENT_NEW_DASHBOARD:
    //   return {
    //     ...state,
    //     patientNewDashboard: action.payload,
    //   };

    case LOGIN_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        // eslint-disable-next-line no-param-reassign
        draft.user = null;
      });
    }

    case LOGIN_SUCCESS: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        // eslint-disable-next-line no-param-reassign
        draft.user = user;
      });
    }

    case LOGIN_FAILURE: {
      return produce(state, () => {
        // Maybe store error
      });
    }

    case LOGOUT: {
      return produce(state, (draft) => {
        // eslint-disable-next-line no-param-reassign
        draft.user = null;
      });
    }

    case SILENT_LOGIN: {
      const { user } = action.payload;

      return produce(state, (draft) => {
        // eslint-disable-next-line no-param-reassign
        draft.user = user;
      });
    }

    case OPEN_SIDEBAR: {
      return {
        ...state,
        sidebarOpen: true,
      };
    }

    case CLOSE_SIDEBAR: {
      return {
        ...state,
        sidebarOpen: false,
      };
    }
    case actions.SET_SERVICE_PROVIDERS:
      return {
        ...state,
        serviceProviders: action.payload,
      };
    case actions.SET_PATIENT_READINGS:
      return {
        ...state,
        patientReadings: action.payload,
      };

    case actions.OPEN_PATIENT_MAIN_DIALOG:
      return {
        ...state,
        openPatientMainDialog: action.payload,
      };

    case actions.OPEN_PATIENT_READINGS_DIALOG:
      return {
        ...state,
        openPatientReadingsDialog: action.payload,
      };

    case actions.SET_TEMPLATE:
      return {
        ...state,
        setTemplate: action.payload,
      };
    default:
      return state;
  }
};
